import { useSettingMenu, useSettingMenuState } from '@/hooks/useSettingMenu';
import { createContext } from 'react';

export const SettingMenuContext = createContext({} as useSettingMenuState);

type SettingMenuProviderProps = {
    children: JSX.Element;
};
export const SettingMenuProvider = (props: SettingMenuProviderProps) => {
    const { children } = props;
    const sm = useSettingMenu();
    return (
        <SettingMenuContext.Provider value={sm}>
            {children}
        </SettingMenuContext.Provider>
    );
};
